/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { Link } from "@packages/framework";
import { URL_APP_STORE, URL_PLAY_STORE } from "@packages/sdk";
import { forwardRef } from "react";

import { spacing } from "../../../../../global/emotion";
import { AppleIcon, GooglePlayIcon } from "../../icons/Icon/ExternalIcons";
import type { ButtonProps } from "../Button/Button.emotion";
import { Button } from "../Button/Button.emotion";
import { Text } from "../Text/Text.emotion";

const buttonStyle: Interpolation = {
  gap: spacing.s,
  height: 48,
  justifyContent: "center",
  lineHeight: "12px",
  width: "100%",
};
const divStyle: Interpolation = {
  alignItems: "start",
  display: "flex",
  flexDirection: "column",
  lineHeight: "16px",
  marginTop: -2,
};

export type DownloadAppButtonProps = Omit<
  ButtonProps,
  "color" | "endIcon" | "size" | "startIcon" | "variant"
> & {
  store?: "apple" | "google";
};

export const DownloadAppButton = forwardRef<any, DownloadAppButtonProps>(
  ({ store = "apple", ...props }, ref) => {
    const DeterminedExternalIcon =
      store === "apple" ? (
        <AppleIcon />
      ) : (
        <GooglePlayIcon height={24} width={24} />
      );

    return (
      <Button asChild ref={ref} css={buttonStyle} variant="outline" {...props}>
        <Link href={store === "apple" ? URL_APP_STORE : URL_PLAY_STORE}>
          {DeterminedExternalIcon}
          <div css={divStyle}>
            <Text size="m" type="detail">
              {store === "apple" ? "Download on the" : "Get it on"}
            </Text>
            {store === "apple" ? "App Store" : "Google Play"}
          </div>
        </Link>
      </Button>
    );
  },
);

DownloadAppButton.displayName = "DownloadAppButton";
